export default __webpack_public_path__ + "static/media/roadmap.d6ab9154.png";